import React, { useState } from 'react';
import { BookOpenIcon } from 'lucide-react';
export const PottyBookBuilder = () => {
  // State for each question's input
  const [situation, setSituation] = useState('');
  const [reader, setReader] = useState('');
  const [interests, setInterests] = useState('');
  const [routine, setRoutine] = useState('');
  const [reward, setReward] = useState('');
  // Handle tag click to add to input
  const handleTagClick = (text: string, currentValue: string, setter: React.Dispatch<React.SetStateAction<string>>) => {
    // If the input is empty, just set it to the tag text
    if (currentValue.trim() === '') {
      setter(text);
    } else {
      // Otherwise, append with a comma and space
      setter(currentValue.trim() + ', ' + text);
    }
  };
  // Questions and their associated tags
  const questions = [{
    id: 'situation',
    question: '1. Describe your potty training situation',
    value: situation,
    setter: setSituation,
    tags: ['just started', 'accidents', 'going well', 'sitting on potty no results', 'scared', 'forgets sometimes', 'tells you before going']
  }, {
    id: 'reader',
    question: '2. Tell us about the reader',
    value: reader,
    setter: setReader,
    tags: ['2 years old', 'boy', 'girl', '(name)']
  }, {
    id: 'interests',
    question: '3. What is your child into?',
    value: interests,
    setter: setInterests,
    tags: ['cars', 'unicorns', 'playground', 'puppies', 'animals', 'dinosaurs']
  }, {
    id: 'routine',
    question: "4. What's your potty routine like?",
    value: routine,
    setter: setRoutine,
    tags: ['morning routine', 'after meals', 'before bath', 'timer-based', 'regular reminders', 'watching for signals', 'underwear not diapers']
  }, {
    id: 'reward',
    question: '5. How do you celebrate potty success?',
    value: reward,
    setter: setReward,
    tags: ['sticker chart', 'small treats', 'high fives', 'special song', 'dance party', 'extra playtime', 'telling family members']
  }];
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // Here you would handle the submission to create the book
    console.log({
      situation,
      reader,
      interests,
      routine,
      reward
    });
    // For now, just alert with the values
    alert('Book details submitted! Check console for values.');
  };
  return <div className="max-w-3xl mx-auto p-6 bg-[#FFFAE4]" data-id="element-759">
      <div className="text-center mb-8" data-id="element-760">
        <h1 className="text-3xl font-bold text-[#6B4B3E] mb-2" data-id="element-761">
          Potty Book Builder
        </h1>
        <p className="text-[#6B4B3E]/80" data-id="element-762">
          Create a personalized potty training book for your little one!
        </p>
      </div>
      <form onSubmit={handleSubmit} className="space-y-8" data-id="element-763">
        {questions.map(q => <div key={q.id} className="bg-white rounded-xl p-6 shadow-sm border border-[#E5C1A9]" data-id="element-764">
            <label className="block text-[#6B4B3E] font-medium mb-2" data-id="element-765">
              {q.question}
            </label>
            <textarea value={q.value} onChange={e => q.setter(e.target.value)} className="w-full px-4 py-2 border-2 border-[#E5C1A9] rounded-xl focus:outline-none focus:border-[#D4A088] min-h-[80px] text-[#6B4B3E]" placeholder="Type or select tags below" data-id="element-766" />
            <div className="flex flex-wrap gap-2 mt-3" data-id="element-767">
              {q.tags.map((tag, index) => <button key={index} type="button" onClick={() => handleTagClick(tag, q.value, q.setter)} className="px-3 py-1 bg-[#FFF0E6] text-[#6B4B3E] text-sm rounded-full border border-[#E5C1A9] hover:bg-[#E5C1A9] transition-colors" data-id="element-768">
                  {tag}
                </button>)}
            </div>
          </div>)}
        <button type="submit" className="w-full px-6 py-3 bg-[#D4A088] text-white rounded-full text-lg font-medium hover:bg-[#C28B73] transition-colors flex items-center justify-center" data-id="element-769">
          <BookOpenIcon size={20} className="mr-2" data-id="element-770" />
          Create Potty Book
        </button>
      </form>
    </div>;
};